export enum BookingMode {
  Default = 'Default',
  MultiplePersons = 'MultiplePersons',
  Unknown = 'Unknown',
}
